










import { Component, Prop, Vue } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
@Component
export default class Container extends Vue {
  @Prop({ default: false }) isMobileScreen;

  get imageUrl() {
    return `${vxm.configs.getGlobalConfigValue(
      'CONTEXT_URL_COMPANY_LOGO_URL_ALIAS',
    )}/${vxm.users.getCompanyCode}/CANDIDATEPORTAL/DownloadAppsBackground.png`;
  }

  get classNames(): string {
    return this.isMobileScreen ? '' : 'p-5';
  }
  
}
